import { sub } from 'date-fns';
import { Moment } from 'moment';
import { ToastOptions } from 'react-toastify';

export const contextStorageKey = 'iatm_rms_context';
export const defaultContext = 'bva';

export type Order = 'asc' | 'desc';

export function desc<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

export function stableSort<T>(array: T[], cmp: (a: T, b: T) => number) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

export function getSorting<K extends keyof any>(
    order: Order,
    orderBy: K,
): (a: { [key in K]: number | string | Moment }, b: { [key in K]: number | string | Moment }) => number {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

export const removeAt = <T>(arr: T[], index: number): T[] => [...arr.slice(0, index), ...arr.slice(index + 1)];
export const updateAt = <T>(arr: T[], item: T, index: number): T[] => [
    ...arr.slice(0, index),
    item,
    ...arr.slice(index + 1),
];

export const errorToastConfig: ToastOptions = {
    autoClose: 6000,
    hideProgressBar: true,
    pauseOnHover: true,
    closeButton: false,
    closeOnClick: true,
    type: 'error' as const,
};

export const successToastConfig: ToastOptions = {
    autoClose: 4000,
    hideProgressBar: true,
    pauseOnHover: true,
    closeButton: false,
    closeOnClick: true,
    type: 'success' as const,
};

export const infoToastConfig: ToastOptions = {
    autoClose: 3000,
    hideProgressBar: true,
    pauseOnHover: true,
    closeButton: false,
    closeOnClick: true,
    type: 'info' as const,
    toastId: 'info',
};

export const safeParse = (s?: string | null) => {
    try {
        return s ? JSON.parse(s) : s;
    } catch (e) {
        return s;
    }
};

export const getTwoDaysAgo = () => sub(new Date(), { days: 2 });
